<template>
  <div class="image-viewer" v-if="show">
    <div class="viewer-overlay" @click="handleClose">
      <div class="viewer-content">
        <!-- <div class="viewer-header">
        <h3>{{ title }}</h3>
        <i class="el-icon-close" @click="handleClose"></i>
      </div> -->
        <div class="viewer-body">
          <img
            :src="imageUrl"
            class="viewer-image"
            mode="widthFix"
            alt="预览图片"
          />
        </div>
        <!-- <div class="viewer-footer">
        <div class="image-info">{{ imageInfo }}</div>
      </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageViewer",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    imageUrl: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "图片预览",
    },
    imageInfo: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClose() {
      console.log("关闭图片查看器");

      // this.$emit("update:show", false);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.image-viewer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.viewer-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
}

.viewer-content {
  position: relative;
  /* width: 90%; */
  /* max-width: 800px; */
  /* height: 90%; */
  /* max-height: 600px; */
  /* background-color: #ffffff; */

  /* border-radius: 8px; */
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
  display: flex;
  flex-direction: column;
  z-index: 10001;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.viewer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eaeaea;
}

.viewer-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.viewer-header i {
  font-size: 18px;
  color: #999;
  cursor: pointer;
}

.viewer-body {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 20px; */
  overflow: hidden;
}

.viewer-image {
  /* max-width: 100%;
  max-height: 100%; */
  width: 50%;
  max-height: 100vh;
  /* object-fit: contain; */
}

.viewer-footer {
  padding: 15px 20px;
  border-top: 1px solid #eaeaea;
  text-align: center;
}

.image-info {
  font-size: 14px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/ImageViewer/index.vue